import { takeEvery, put, call } from 'redux-saga/effects';
import { npcLogConstant } from 'src/redux/actions/constant';
import npcLogService from 'src/services/apiServices/npcLogService/npcLogService';

function* getNpcActivityTypes(): any {
  try {
    yield put({ type: npcLogConstant.GET_NPC_ACTIVITY_TYPES_LOADER });
    const response = yield call(npcLogService.getActivityTypes);
    if (response?.status === 200) {
      yield put({ type: npcLogConstant.GET_NPC_ACTIVITY_TYPES_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: npcLogConstant.GET_NPC_ACTIVITY_TYPES_FAILURE, payload: error });
  }
}

function* getNpcActivityTypesSaga() {
  yield takeEvery(npcLogConstant.GET_NPC_ACTIVITY_TYPES_REQUEST, getNpcActivityTypes);
}

export default getNpcActivityTypesSaga;
